import React from 'react';

import styles from './Menu.module.css';
import Title from './Title';
import Button from '../UI/Button/Button';

const Menu = (props) => {
  const selectListHandler = (index) => (event) => {
    props.onSelectYear(index);
  };
  var tmp = [];
  for (var i = 2019; i < 2027; i++) {
    tmp.push(i);
  }
  var menuItems = tmp.map((i) => {
    return (
      <Button key={i} onClick={selectListHandler(i)}>
        {i}
      </Button>
    );
  });
  return (
    <div className={styles.menu}>
      <Title />
      {menuItems}
    </div>
  );
};

export default Menu;
